'use strict';
module.exports = require('../../full/object/get-own-property-symbols');
